import type {Theme, Components} from "../..";

type TextFieldOverrides = Components<Theme>["MuiTextField"];

/**
 * @typedef {undefined} TextFieldSize
 */

declare module "@mui/material/TextField" {
    interface BaseTextFieldProps {
        /**
         * @param {TextFieldSize} [size] - The Next theme has no size variants for InputBase.
         * Don't use this prop if you want the Next theme.
         */
        size?: "medium" | "small";
    }
}

const overrides: TextFieldOverrides = {
    defaultProps: {
        variant: "outlined",
    },
};

export default overrides;
